































































































































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { types2Arr } from '@/data/types';
import { fetchUnifiedLocations } from '@/utils/filters';
import { getMyOptionsPrescriber, getMyOptionsPrescriberStats, postBookingPrescriber, patchBookingPrescriber } from '@/api/api';
import { BACKEND_URL } from '@/helpers/constants';
import departments from '@/data/departments';
import LocationFilterComponent from '@/components/LocationFilterComponent.vue';
import { formatBookingStatus } from '@/data/bookingStatus';
import OptionsReportModal from '@/components/prescriber/OptionsReportModal.vue';
import Secret from '@/components/common/Secret.vue';

@Component({
    components: { LocationFilterComponent, OptionsReportModal, Secret },
    filters: {
        formatOptionStatus(status: string) {
            const map: Record<string, string> = {
                accepted: 'Acceptée',
                pending: 'En attente',
                refused: 'Refusée',
                canceled: 'Annulée',
            };
            return map[status] || status;
        },
        formatLotStatus(status: string) {
            const map: Record<string, string> = {
                available: 'Libre',
                optionned: 'Optionné',
                booked:    'Réservé',
                acted:     'Acté',
                retired:   'Retiré de la vente',
                nc:        'NC',
                sold:      'Vendu',
            };
            return map[status] || status;
        },
        formatPrice(value: number) {
            if (!value) return '—';
            return value.toLocaleString('fr-FR');
        },
        formatBookingStatus,
    },
})
export default class OptionsPrescriber extends Vue {
    searchQuery: string = '';
    statusFilter: string = '';
    localPrivateMode: boolean = false;
    BACKEND_URL = BACKEND_URL;

    // Location filters
    selectedCountry: string = '';
    selectedLocations: any[] = [];
    locationDetailsCache: any[] = [];
    filterRegions: string[] = [];
    filterDepartements: string[] = [];
    filterCities: string[] = [];

    // Lot filters
    budgetMin: number | null = null;
    budgetMax: number | null = null;
    surfaceMin: number | null = null;
    surfaceMax: number | null = null;
    selectedRooms: string[] = [];
    selectedFloors: string[] = [];

    options: any[] = [];
    loading: boolean = false;
    loadError: string | null = null;

    currentPage: number = 1;
    pageSize: number = 10;
    allLoaded: boolean = false;
    loadingMore: boolean = false;

    totalOptions: number = 0;
    totalPending: number = 0;
    totalAccepted: number = 0;
    totalCanceled: number = 0;

    // Info popup
    showInfoPopup: boolean = false;
    selectedOption: any = null;

    // Booking popup & confirmation
    showBooking: boolean = false;
    optionToBook: any = null;
    bookingFormType: string = '';
    bookingDownloaded: boolean = false;
    bookingLoading: boolean = false;
    showConfirmationPopup: boolean = false;
    forceBooking: boolean = false;

    selectedOptionIds: number[] = [];
    showOptionsReportModal: boolean = false;

    async mounted() {
        this.initializeUserColor();
        await Promise.all([this.loadOptions(), this.fetchStats()]);
    }

    async fetchStats() {
        try {
            const { data } = await getMyOptionsPrescriberStats();
            this.totalOptions = data.total;
            this.totalPending = data.pending;
            this.totalAccepted = data.accepted;
            this.totalCanceled = data.canceled;
        } catch {
            // fallback: header counts stay 0 until options load
        }
    }

    async loadOptions() {
        this.loading = true;
        this.loadError = null;
        this.options = [];
        this.currentPage = 1;
        this.allLoaded = false;
        try {
            const { data } = await getMyOptionsPrescriber(1, this.pageSize);
            const items = Array.isArray(data) ? data : [];
            this.options = this.mapOptions(items);
            if (items.length < this.pageSize) this.allLoaded = true;
        } catch (error) {
            this.loadError = 'Impossible de charger les options.';
        } finally {
            this.loading = false;
        }
    }

    async loadMoreOptions() {
        this.loadingMore = true;
        try {
            const { data } = await getMyOptionsPrescriber(this.currentPage + 1, this.pageSize);
            const items = Array.isArray(data) ? data : [];
            this.options = [...this.options, ...this.mapOptions(items)];
            this.currentPage++;
            if (items.length < this.pageSize) this.allLoaded = true;
        } finally {
            this.loadingMore = false;
        }
    }



    private mapOptions(raw: any[]): any[] {
        return raw.map((o: any) => {
            const customer = o.customer || {};
            const lot = o.lot || {};
            const program = lot.program || (o.denounce && o.denounce.program) || {};
            const addr = program.address || {};
            const prospect = `${customer.first_firstname || ''} ${customer.first_lastname || ''}`.trim();

            // Address for display & filtering
            const city: string = addr.city || '';
            const postalCode: string = addr.postal_code || '';
            const departmentCode: string = postalCode.substring(0, 2);
            const dept = departments.find((d: any) => d.code === departmentCode);
            const address = [addr.street, postalCode, city].filter(Boolean).join(' ');

            // Booking status for this lot from customer's bookings
            const bookings: any[] = customer.bookings || [];
            const booking = bookings.find((b: any) => b.lot && b.lot.id === lot.id && !b.deleted_at);

            return {
                id: o.id,
                prospect,
                customerId: customer.id,
                programmeId: program.id,
                programmeName: program.name,
                address,
                city,
                postalCode,
                departmentCode,
                regionCode: dept ? dept.region_code : '',
                country: 'FR',
                lotId: lot.id,
                lotName: lot.name,
                lotType: lot.type2 || lot.type,
                lotFloor: lot.floor,
                surface: lot.surface_carrez,
                price: lot.price,
                tauxCommission: o.taux_commission,
                optionComment: o.delete_comments || null,
                denounceComment: (o.denounce && o.denounce.delete_comments) || null,
                denounceUpdatedAt: (o.denounce && o.denounce.updated_at) ? this.formatDate(o.denounce.updated_at) : null,
                lotStatus: lot.status,
                status: o.status,
                createdAtRaw: o.created_at ? new Date(o.created_at).getTime() : 0,
                endAt: o.end_at ? this.formatDate(o.end_at) : null,
                updatedAt: o.updated_at ? this.formatDate(o.updated_at) : null,
                bookingStatus: booking ? booking.status : null,
                bookingId: booking ? booking.id : null,
            };
        });
    }

    private formatDate(raw: string): string {
        if (!raw) return '';
        const d = new Date(raw);
        if (isNaN(d.getTime())) return raw;
        return d.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' });
    }

    getCommissionDisplay(tauxCommission: any): string {
        if (tauxCommission === null || tauxCommission === undefined || tauxCommission === '') {
            return 'NC';
        }

        const value = Number(tauxCommission);
        if (isNaN(value)) {
            return 'NC';
        }

        return `${value.toLocaleString('fr-FR', { maximumFractionDigits: 2 })}%`;
    }

    get pendingCount() { return this.totalPending; }
    get acceptedCount() { return this.totalAccepted; }
    get canceledCount() { return this.totalCanceled; }

    get statsDisponibles() {
        return this.options.filter(o => o.lotStatus === 'available').length;
    }

    get statsOptionnes() {
        return this.options.filter(o => o.lotStatus === 'optionned').length;
    }

    get statsReserves() {
        return this.options.filter(o => o.lotStatus === 'reserved').length;
    }

    get roomOptions() {
        const existing = new Set(this.options.map((o: any) => o.lotType).filter(Boolean));
        return types2Arr.filter(t => existing.has(t.value));
    }

    get floorOptions() {
        const existing = [...new Set(this.options.map((o: any) => String(o.lotFloor)).filter(Boolean))];
        return existing
            .sort((a, b) => {
                if (a === 'RDC' || a === 'RDJ') return -1;
                if (b === 'RDC' || b === 'RDJ') return 1;
                const aNum = parseInt(a);
                const bNum = parseInt(b);
                if (!isNaN(aNum) && !isNaN(bNum)) return aNum - bNum;
                return a.localeCompare(b);
            })
            .map(f => ({ text: f, value: f }));
    }

    get fetchUnifiedLocations() {
        return fetchUnifiedLocations;
    }

    matchesLocationFilter(o: any): boolean {
        if (this.selectedCountry !== '' && o.country !== this.selectedCountry) return false;

        if (this.selectedCountry === 'FR') {
            const hasRegions = this.filterRegions.length > 0;
            const hasDepts = this.filterDepartements.length > 0;
            const hasCities = this.filterCities.length > 0;

            if (hasRegions || hasDepts || hasCities) {
                const inRegion = hasRegions && this.filterRegions.includes(o.regionCode);
                const inDept = hasDepts && this.filterDepartements.includes(o.departmentCode);
                const inCity = hasCities && this.filterCities.some((c: string) =>
                    o.city && o.city.toLowerCase() === c.toLowerCase()
                );
                if (!inRegion && !inDept && !inCity) return false;
            }
        }
        return true;
    }

    matchesLotFilters(o: any): boolean {
        if (this.budgetMin !== null && o.price < this.budgetMin) return false;
        if (this.budgetMax !== null && o.price > this.budgetMax) return false;
        if (this.surfaceMin !== null && o.surface < this.surfaceMin) return false;
        if (this.surfaceMax !== null && o.surface > this.surfaceMax) return false;
        if (this.selectedRooms.length > 0 && !this.selectedRooms.includes(o.lotType)) return false;
        if (this.selectedFloors.length > 0 && !this.selectedFloors.includes(String(o.lotFloor))) return false;
        return true;
    }

    get filteredOptions() {
        return this.options.filter(o => {
            const matchSearch = !this.searchQuery ||
                (o.prospect && o.prospect.toLowerCase().includes(this.searchQuery.toLowerCase())) ||
                (o.programmeId && String(o.programmeId).includes(this.searchQuery)) ||
                (o.programmeName && o.programmeName.toLowerCase().includes(this.searchQuery.toLowerCase())) ||
                (o.lotName && o.lotName.toLowerCase().includes(this.searchQuery.toLowerCase())) ||
                (o.city && o.city.toLowerCase().includes(this.searchQuery.toLowerCase()));
            const matchStatus = !this.statusFilter || o.status === this.statusFilter;
            return matchSearch && matchStatus && this.matchesLocationFilter(o) && this.matchesLotFilters(o);
        });
    }

    onUnifiedLocationChange(values: any[]) {
        if (!values || values.length === 0) {
            this.filterRegions = [];
            this.filterDepartements = [];
            this.filterCities = [];
            this.selectedLocations = [];
            this.locationDetailsCache = [];
            return;
        }
        this.locationDetailsCache = values;
        const regions: string[] = [];
        const departements: string[] = [];
        const cities: string[] = [];
        values.forEach((location: any) => {
            if (location.type === 'Region') {
                regions.push(location.value);
            } else if (location.type === 'Departement') {
                departements.push(location.value);
            } else if (location.type === 'Ville') {
                const cityName = location.text.split(' ')[0];
                cities.push(cityName);
                if (location.departmentCode) departements.push(location.departmentCode);
            } else if (location.type === 'Code postal') {
                departements.push(location.value.substring(0, 2));
            }
        });
        this.filterRegions = regions;
        this.filterDepartements = [...new Set(departements)];
        this.filterCities = cities;
        this.selectedLocations = values.map((v: any) => v.value);
    }

    removeLocation(index: number) {
        this.locationDetailsCache.splice(index, 1);
        this.selectedLocations = this.locationDetailsCache.map((v: any) => v.value);
        this.onUnifiedLocationChange(this.locationDetailsCache);
    }

    getLocationTypeClass(type: string): string {
        const m: any = { 'Region': 'type-region', 'Departement': 'type-departement', 'Ville': 'type-ville', 'Code postal': 'type-postal' };
        return m[type] || '';
    }

    getLocationTypeIcon(type: string): string {
        const m: any = { 'Region': '🌍', 'Departement': '📍', 'Ville': '🏙️', 'Code postal': '📮' };
        return m[type] || '📌';
    }

    toggleLocalPrivateMode() { this.localPrivateMode = !this.localPrivateMode; }
    toggleRoom(value: string) { const i = this.selectedRooms.indexOf(value); i > -1 ? this.selectedRooms.splice(i, 1) : this.selectedRooms.push(value); }
    toggleFloor(value: string) { const i = this.selectedFloors.indexOf(value); i > -1 ? this.selectedFloors.splice(i, 1) : this.selectedFloors.push(value); }

    resetFilters() {
        this.searchQuery = '';
        this.statusFilter = '';
        this.selectedCountry = '';
        this.selectedLocations = [];
        this.locationDetailsCache = [];
        this.filterRegions = [];
        this.filterDepartements = [];
        this.filterCities = [];
        this.budgetMin = null;
        this.budgetMax = null;
        this.surfaceMin = null;
        this.surfaceMax = null;
        this.selectedRooms = [];
        this.selectedFloors = [];
    }

    // ── Selection & Report ───────────────────────────────────────────────────

    isOptionSelected(id: number): boolean {
        return this.selectedOptionIds.includes(id);
    }

    toggleOptionSelection(id: number) {
        const idx = this.selectedOptionIds.indexOf(id);
        if (idx > -1) this.selectedOptionIds.splice(idx, 1);
        else this.selectedOptionIds.push(id);
    }

    get selectedOptions(): any[] {
        return this.options.filter(o => this.selectedOptionIds.includes(o.id));
    }

    get allVisibleOptionIds(): number[] {
        return this.filteredOptions.map(o => o.id);
    }

    toggleAllOptions(event: Event) {
        const checked = (event.target as HTMLInputElement).checked;
        if (checked) {
            this.allVisibleOptionIds.forEach(id => {
                if (!this.selectedOptionIds.includes(id)) this.selectedOptionIds.push(id);
            });
        } else {
            this.allVisibleOptionIds.forEach(id => {
                const idx = this.selectedOptionIds.indexOf(id);
                if (idx > -1) this.selectedOptionIds.splice(idx, 1);
            });
        }
    }

    // ── Booking ──────────────────────────────────────────────────────────────

    openBookingPopup(option: any) {
        this.optionToBook = option;
        this.bookingFormType = '';
        this.bookingDownloaded = false;
        this.forceBooking = false;
        this.showBooking = true;
    }

    async confirmBooking() {
        if (!this.optionToBook || !this.optionToBook.lotId) return;
        this.bookingLoading = true;
        const $vs = (this as any).$vs;
        try {
            const { data } = await postBookingPrescriber(this.optionToBook.lotId, this.optionToBook.customerId, !!this.forceBooking);
            const bookingId: number = (data as any).id;
            this.showBooking = false;
            $vs.notify({ color: 'success', position: 'top-right', title: 'Modification', text: 'La réservation a bien été posée' });
            this.$router.push({
                name: 'bookingPrescriber',
                params: { bookingID: bookingId.toString() },
            });
        } catch (error) {
            this.handleBookingError(error);
        } finally {
            this.bookingLoading = false;
        }
    }

    async confirmBookingWithSelfForm() {
        if (!this.optionToBook || !this.optionToBook.lotId) return;
        this.bookingLoading = true;
        const $vs = (this as any).$vs;
        try {
            const { data } = await postBookingPrescriber(this.optionToBook.lotId, this.optionToBook.customerId, !!this.forceBooking);
            const bookingId: number = (data as any).id;
            await patchBookingPrescriber(bookingId, { self_filled_form: true, progression: 'signature' } as any);
            this.showBooking = false;
            $vs.notify({ color: 'success', position: 'top-right', title: 'Modification', text: 'La réservation a bien été posée' });
            this.$router.push({
                name: 'bookingPrescriber',
                params: { bookingID: bookingId.toString() },
            });
        } catch (error) {
            this.handleBookingError(error);
        } finally {
            this.bookingLoading = false;
        }
    }

    handleBookingError(error: any) {
        const $vs = (this as any).$vs;
        const resp = error.response;

        if (resp && resp.data && resp.data.message &&
            resp.data.message.includes("une réservation en cours") &&
            !this.forceBooking) {
            this.showConfirmationPopup = true;
            return;
        }

        let message;
        if (resp && resp.data && typeof resp.data.message === 'string') {
            message = resp.data.message;
        } else if (resp) {
            message = `Erreur ${resp.status} lors de la réservation.`;
        } else {
            message = 'Erreur réseau ou serveur indisponible.';
        }

        $vs.notify({
            color: 'danger',
            position: 'top-right',
            title: 'Réservation échouée',
            text: message
        });

        if (this.optionToBook && this.optionToBook.customerId) {
            this.$router.push({
                name: 'editProspect',
                params: { customerID: this.optionToBook.customerId.toString() },
                query: { errorMsg: message },
            });
        }
    }

    proceedWithBookingAnyway() {
        this.forceBooking = true;
        this.showConfirmationPopup = false;
        
        if (!this.optionToBook) return;
        
        if (this.bookingFormType === 'plugimmo') {
            this.confirmBooking();
        } else if (this.bookingFormType === 'self') {
            this.confirmBookingWithSelfForm();
        }
    }

    // ── Color / theme ─────────────────────────────────────────────────────────

    setPrimaryColor(hexColor: string): void {
        const r = parseInt(hexColor.slice(1, 3), 16);
        const g = parseInt(hexColor.slice(3, 5), 16);
        const b = parseInt(hexColor.slice(5, 7), 16);
        document.documentElement.style.setProperty('--primary-color', hexColor);
        document.documentElement.style.setProperty('--vs-primary', `${r}, ${g}, ${b}`);
        document.documentElement.style.setProperty('--vs-personal_color', `${r}, ${g}, ${b}`);
    }

    getUserPrimaryColor(): string {
        const authJson = localStorage.getItem('auth');
        if (authJson) {
            try { return JSON.parse(authJson).personal_color || '#ff5733'; } catch { return '#ff5733'; }
        }
        return '#ff5733';
    }

    initializeUserColor(): void { this.setPrimaryColor(this.getUserPrimaryColor()); }
}
